import app from '@/app';
import templateUrl from './cost-table-historic.html';

/* @ngInject */
function Controller($controller, CostTableHistoric, Principal) {
	var $ctrl = this;

  $ctrl.currentAccount = null;

  Principal.identity().then(account => {
    $ctrl.currentAccount = account;
    })

    $controller('AbstractController', { $ctrl });

    this.$onInit = function() {
      CostTableHistoric.query(
        {
          idplan: $ctrl.idplan,
          version: $ctrl.version,
        },
        data => {
          $ctrl.entities = data.content;
          $ctrl.count = data.totalElements;
        }
      );
    };
    


}

app.component('costTableHistoric', {
	templateUrl,
	controller: Controller,
	require: {
		parent: '^planHistoric'
	},
	bindings: {
		$transition$: '<',
		idplan: '<',
    version: '<'
	}
});

